document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.polo-slider').forEach((slider) => {
    const track = slider.querySelector('.polo-slider__track');
    const arrows = slider.querySelectorAll('.polo-slider__arrow');
    if (!track || !arrows.length) return;

    arrows.forEach((arrow) => {
      arrow.addEventListener('click', () => {
        const direction = parseInt(arrow.dataset.direction, 10) || 1;
        const item = track.querySelector('.polo-slider__item');
        const scrollAmount = item ? item.getBoundingClientRect().width + 20 : 280;
        track.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
      });
    });
  });
});